import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type LookupLegalEntityResult = {
  found: boolean;
  name: string;
  /**
   * The registry's own Latin name. Empty for many companies -- XYP simply does
   * not hold one. Never substitute a transliteration: a Mongolian company name
   * is usually itself a transliteration of a foreign phrase, so
   * "Эйрвингс Бюро ХХК" would come back "Eyrvings Byuro" rather than its real
   * registered name, "Airwings Bureau LLC".
   */
  nameEn?: string;
};

export type LookupCitizenResult = {
  found: boolean;
  lastname: string;
  firstname: string;
};

export const lookupLegalEntity = async (regNumber: string): Promise<LookupLegalEntityResult> => {
  return httpRequest.post("/prt/pub/xyp/lookup-legal-entity", { regNumber });
};

export const lookupCitizen = async (regNumber: string): Promise<LookupCitizenResult> => {
  return httpRequest.post("/prt/pub/xyp/lookup-citizen", { regNumber });
};
